import { connect } from 'react-redux';
import UserSettings from './UserSettings';
import {
  createUser,
  deleteUser,
  loadUsers,
  updateUser,
  inviteUser,
  loadMySubscriptionPlan,
} from '../../../../redux/actions/user';
import { selectUsers } from '../../../../redux/selectors/users';
import { selectGroups } from '../../../../redux/selectors/groups';
import { loadGroups } from '../../../../redux/actions/groups';
import { selectDepartments } from '../../../../redux/selectors/departments';
import { loadDepartments } from '../../../../redux/actions/departments';

const mapStateToProps = (state) => {
  return {
    users: selectUsers(state),
    groups: selectGroups(state),
    departments: selectDepartments(state),
    status: state.user.usersStatus,
    groupsStatus: state.groups.status,
    departmentsStatus: state.departments.status,
    user: state.user.user,
    mySubscriptionPlan: state.user.mySubscriptionPlan,
    mySubscriptionPlanStatus: state.user.mySubscriptionPlanStatus,
  };
};

const mapDispatchToProps = {
  loadUsers,
  loadGroups,
  loadDepartments,
  createUser,
  deleteUser,
  updateUser,
  inviteUser,
  loadMySubscriptionPlan,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserSettings);
